import "vuetify/styles"
import { createVuetify } from "vuetify"
import { aliases, mdi } from "vuetify/iconsets/mdi"
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n"
import { useI18n } from "vue-i18n"

import "@mdi/font/css/materialdesignicons.css"

import colors from "vuetify/util/colors"
import { i18n } from "./i18n"

export default createVuetify({
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n })
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi
    }
  },
  theme: {
    defaultTheme: "light",
    // Generates text-/bg-/border-primary-lighten-1 and -2 (Vuetify 2 had these
    // as "primary lighten-2").
    variations: {
      colors: ["primary"],
      lighten: 2,
      darken: 0
    },
    themes: {
      light: {
        dark: false,
        colors: {
          primary: colors.grey.darken1,
          secondary: "#ffd300" /* Brokk yellow */,
          accent: "#1A1A1A" /* Brokk near-black */,
          success: "#3c8a2e",
          info: "#888888" /* Brokk mid-gray */,
          alert: "#d2492a",
          warning: "#ffd300" /* Brokk yellow */,
          error: "#FF5252" /* Vuetify 2 default red, since Vuetify 3's default (#B00020) is darker */,
          details_background: colors.grey.lighten4,
          muted: "#1e1e1e",
          generic: colors.grey.lighten3
        }
      }
    }
  }
})
